import { IconButton } from "@nova/component-btn"
import { QuestionProps } from "./ChecklistQuestionTypes"
import * as Icons from "@nova/component-icons"

export const ChecklistHeaderQuestion = ({
    spec,
    questionControls,
    autoFocus = false,
}: QuestionProps<"header">) => {
    return (
        <input
            className="bg-gray-700 rounded-lg text-gray-0 border-0"
            value={spec.question}
            onChange={(e) =>
                questionControls.editQuestion(spec.id, { ...spec, question: e.target.value })
            }
            placeholder="Enter a label"
            autoFocus={autoFocus}
        />
    )
}

export const ChecklistHeaderFooter = ({ spec, questionControls }: QuestionProps<"header">) => {
    return (
        <div className="px-8 py-4 flex items-center gap-4">
            <div className="grow" />
            <IconButton
                onClick={() => {
                    questionControls.deleteQuestion(spec.id)
                }}
            >
                <Icons.Icon
                    Icon={Icons.Trash}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                />
            </IconButton>
        </div>
    )
}
